<div class="container">
  <div class="content">
    <img class="icon" *ngIf="showIcon" [src]="informationPurpleIcon" alt="information" />

    <div [innerHTML]="descriptionHtml" [ngClass]="closeOnly ? 'text-purple' : ''"></div>
  </div>

  <div class="actions" *ngIf="showActions">
    <app-button
      [titulo]="cancelText"
      className="secondary button"
      [disable]="isLoading"
      (keydown.enter)="$event.stopPropagation()"
      (clickAction)="handleCancel()"></app-button>
    <ng-container *ngIf="!closeOnly">
      <app-button
        [titulo]="confirmButtonText"
        className="primary button"
        [disable]="isLoading"
        (keydown.enter)="$event.stopPropagation()"
        (click)="handleConfirm()"></app-button>
    </ng-container>
  </div>
</div>
